module.exports = __webpack_public_path__ + "static/img/me.ac1f67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/me.jpg
// module id = O2OG
// module chunks = 4